import React, { useEffect } from "react";
import { useState } from "react";
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button, Toolbar } from '@progress/kendo-react-buttons';
import {QRCode} from '@progress/kendo-react-barcodes'
import { Input, TextArea } from '@progress/kendo-react-inputs';
import { IconCell } from "./helpers";
import { saveAs } from '@progress/kendo-file-saver';
import { DropDownList } from '@progress/kendo-react-dropdowns';


export const PAList=()=>{
    const [listData,setListData]=useState([]);
    const [resLinks,setResLinks]=useState([]);
    const [select, setSelect] = useState(undefined);
    const [showEdit, setShowEdit]=useState(false);
    const [editType, setEditType]=useState("");
    const [showQR,setShowQR]=useState(false);
    const [showScanLink,setShowScanLink]=useState(false);
    const [showResLink,setShowResLink]=useState(false);

    const [newStatus, setNewStatus]=useState("");
    const [showStatusConfirm,setShowStatusConfirm]=useState(false);

    const getData=()=>{
        const url = "api/index.php/admin/getPAList";
        //console.log(url);
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(data=>{
            //console.log(data);
            setListData(data);
        })
    }

    const makeKey=()=>{
        const url = "api/index.php/admin/assignPAKey";
        //console.log(url);
         const postData = new FormData();

            postData.append("id",select.AreaID);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(data=>{
            console.log(data);
            getData();
        })
    }

    const getReservationLinks=()=>{
        const url = "api/index.php/program/getReservationLinks";
        //console.log(url);
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(data=>{
            //console.log(data);
            setResLinks(data);
        })
    }

    const showDialog=()=>{
        setShowEdit(true);
    }

    const closeDialog=()=>{
        setShowEdit(false);
    }

    const openEdit=()=>{
        setEditType("EDIT");
        showDialog();
    }

    const openNew=()=>{
        setEditType("NEW");
        showDialog();
    }

    const openQR=()=>{
        if (select.AreaID){
            setShowQR(true);
        }
    }

    const closeQR=()=>{
        setShowQR(false);
    }

    const openScan=()=>{
        if (select.AreaID){
            setShowScanLink(true);
        }
    }

    const closeScan=()=>{
        setShowScanLink(false);
    }

    const openRes=()=>{
        if (select.AreaID){
            setShowResLink(true);
        }
    }

    const closeRes=()=>{
        setShowResLink(false);
    }


    const showConfirmStatus=()=>{
        setShowStatusConfirm(true);
    }

    const hideConfirmStatus=()=>{
        setShowStatusConfirm(false);
    }

    const onSelectionChange = React.useCallback(event => {
        console.log(event.startDataItem)
        setSelect(event.startDataItem);
    }, []);


    const BoolCell = (props) => {
        //console.log(props)
        const retVal = props.dataItem.hasKey===1?"Yes":"No";
        const style = props.dataItem.hasKey===1?"nsjgo":"nsjstop";
        return (
            <td {...props.tdProps} className={style}>
                {retVal}
            </td>
        );
    };


    const EditPA=()=>{
        const [frmData,setFrmData]=useState({});
        
        const areaIdChange=(event)=>{
            setFrmData({...frmData,AreaID:event.value});
        }
        const areaNameChange=(event)=>{
            setFrmData({...frmData,AreaName:event.value});
        }
        const contactChange=(event)=>{
            setFrmData({...frmData,ContactName:event.value});
        }
        const phoneChange=(event)=>{
            setFrmData({...frmData,ContactPhone:event.value});
        }
        const descriptionChange=(event)=>{
            setFrmData({...frmData,Description:event.value});
        }
         const locationChange=(event)=>{
            setFrmData({...frmData,Location:event.value});
        }

        const savePA=()=>{
            const url = "api/index.php/admin/updatePA";
            console.log(url);
            const postData = new FormData();
            console.log(frmData);
            postData.append("oldId",editType==="NEW"?"NEW":select.AreaID);
            postData.append("newId",frmData.AreaID);
            postData.append("areaName",frmData.AreaName);
            postData.append("contactName",frmData.ContactName);
            postData.append("contactPhone",frmData.ContactPhone);
            postData.append("status",frmData.Status);
            postData.append("description",frmData.Description);
            postData.append("location",frmData.Location);
            console.log(postData);
            fetch (url,{
                method:"POST",
                body:postData
            }).then(response=>response.json()).then(data=>{
                console.log(data);
                closeDialog();
                getData();
            })
        }

        useEffect(()=>{
            let area={
                AreaID:"",
                AreaName:"",
                ContactName:"",
                ContactPhone:"",
                Status:"CLOSED",
                Description:"",
                Location:""
            }
            if (editType==="EDIT"){
                area.AreaID=select.AreaID;
                area.AreaName=select.AreaName;
                area.ContactName=select.ContactName;
                area.ContactPhone=select.ContactPhone;
                area.Status=select.Status&&select.Status!==""?select.Status:"CLOSED";
                area.Description=select.Description;
                area.Location=select.Location;
            }
            setFrmData(area);
        },[])

        return(
            <Dialog title={editType==="NEW"?"New Program Area":"Edit Program Area"} onClose={closeDialog} width={"30%"}>
                <label>Area Id:</label>
                <Input className={"formField"} value={frmData.AreaID} placeholder="Area ID" maxLength={50} onChange={areaIdChange}/>
                <label>Area Name:</label>
                <Input className={"formField"} value={frmData.AreaName} placeholder="Area Name" maxLength={50} onChange={areaNameChange}/>
                <label>Area Contact:</label>
                <Input className={"formField"} value={frmData.ContactName} placeholder="Contact Name" maxLength={50} onChange={contactChange}/>
                <label>Contact Phone:</label>
                <Input className={"formField"} value={frmData.ContactPhone} placeholder="Contact Phone" maxLength={50} onChange={phoneChange}/>
                <label>Reservation Instructions:</label>
                <TextArea className={"formField"} value={frmData.Description} placeholder="Check-in instructions" maxLength={1000} onChange={descriptionChange}/>
                <label>Check-In Location:</label>
                <Input className={"formField"} value={frmData.Location} placeholder="Check-in location" maxLength={200} onChange={locationChange}/>

                <DialogActionsBar>
                    <Button type="Button" fillMode="solid" size="medium" themeColor="primary" onClick={savePA}>Save</Button>
                    <Button type="Button" fillMode="solid" size="medium" themeColor="base" onClick={closeDialog}>Cancel</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    const ScanLinkViewer=()=>{
        const authArea = select.AreaID;
        const url = window.location.origin + "?act=scan&pid=" + authArea;
        const qrcode = React.createRef();

        const exportQRCode = () => {
            if (!qrcode.current) {
                return;
            }
            qrcode.current.exportImage().then((dataURI) => {
                saveAs(dataURI, "NJ26-" + select.AreaName.replace(/ /g,"_") + '_WaitScan.png');
            });
        };
        return(
            <Dialog onClose={closeScan} title={"Scan Link for " + select.AreaName}>
                <div>
                    <QRCode ref={qrcode} value={url} size={300} renderAs="svg"/>
                </div>
                <div style={{paddingTop:"10px",textAlign:"center"}}>
                    <Button fillMode={'solid'} themeColor={'primary'} onClick={exportQRCode}>
                        Export as Image
                    </Button>
                </div>
                <div>
                    <Input value={url}/>
                </div>
            </Dialog>
        )
    }

    const ResLinkViewer=()=>{
        if (select!=undefined){
            const authArea = select.AreaID;
            let key = "";
            resLinks.forEach(area=>{
                if(area.AreaId===authArea){
                    key = area.APIKey;
                }
            });
            let urlend="";
            if (select.AreaID==="NJ26-FC"){
                urlend="/speakers";
            }else{
                urlend ="/reserve?key=" + key;
            }
            const url = window.location.origin + urlend;
            const qrcode = React.createRef();
    
            const exportQRCode = () => {
                if (!qrcode.current) {
                    return;
                }
                qrcode.current.exportImage().then((dataURI) => {
                    saveAs(dataURI, "NJ26-" + select.AreaName.replace(/ /g,"_") + '_Reservations.png');
                });
            };

         
        return(
            <Dialog onClose={closeRes} title={"Scan Link for " + select.AreaName}>
                <div>
                    <QRCode ref={qrcode} value={url} size={300} renderAs="svg"/>
                </div>
                <div style={{paddingTop:"10px",textAlign:"center"}}>
                    <Button fillMode={'solid'} themeColor={'primary'} onClick={exportQRCode}>
                        Export as Image
                    </Button>
                </div>
                <div>
                    <Input value={url}/>
                </div>
            </Dialog>
        )
        }
    }




    const QRViewer=()=>{
        let authKey="5ef087a1f70b365aee61cf78614f4a77d60dcaf5f7f6f45ecf6770920c9e7a0c";
        const authArea = select.AreaID;
        const url = window.location.origin + "/authorize?auth=" + authKey + "&id="+authArea;
        const qrcode = React.createRef();

        const exportQRCode = () => {
            if (!qrcode.current) {
                return;
            }
            qrcode.current.exportImage().then((dataURI) => {
                saveAs(dataURI, "NJ26-" + select.AreaName.replace(/ /g,"_") + '_Access.png');
            });
        };
        return(
            <Dialog onClose={closeQR} title={"Authorization Code for " + select.AreaName}>
                <div>
                    <QRCode ref={qrcode} value={url} size={300} renderAs="svg"/>
                </div>
                <div style={{paddingTop:"10px",textAlign:"center"}}>
                    <Button fillMode={'solid'} themeColor={'primary'} onClick={exportQRCode}>
                        Export as Image
                    </Button>
                </div>
            </Dialog>
        )
    }

    const changeStatus=(event)=>{
        console.log(event.value);
        setNewStatus(event.value.value);
    }

    const setStatus=()=>{
        console.log("Set New Status");
        const url = "api/index.php/program/setStatus";
        const postData = new FormData();
        if (select.AreaID!==""){
            postData.append("id",select.AreaID);
            postData.append("status", newStatus);
            fetch (url,{
                method:"POST",
                body:postData
            }).then(response=>response.json()).then(data=>{
                //console.log(data);
                getData();
                hideConfirmStatus();
            })
        }
    }

    const ConfirmStatus=()=>{
        return(
            <Dialog title="Set Area Status" closeIcon={false}>
                {select?
                    <p>Are you sure you want to change the status for {select.AreaName} to {newStatus}?</p>
                :
                    <p>Please select a program area from the list.</p>
                }
                <DialogActionsBar>
                    {select?<Button size="large" themeColor='primary' onClick={setStatus}>Continue</Button>:null}
                    <Button size="large" onClick={hideConfirmStatus}>Cancel</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    useEffect(()=>{
        console.log(select);
    },[select])

    useEffect(()=>{
        console.log(newStatus);
        if (newStatus!==""){
            showConfirmStatus();
        }
    },[newStatus])

    useEffect(()=>{
        getData();
        getReservationLinks();
    },[])

    return(
        <>
        {showEdit?<EditPA type="EDIT"/>:null}
        {showQR?<QRViewer></QRViewer>:null}
        {showScanLink?<ScanLinkViewer></ScanLinkViewer>:null}
        {showResLink?<ResLinkViewer></ResLinkViewer>:null}
        
        {showStatusConfirm?<ConfirmStatus></ConfirmStatus>:null}
        <Toolbar>
            <Button title="New" onClick={openNew}>New</Button>
            <Button title="Edit" onClick={openEdit}>Edit</Button>
            <Button title="Make Key" onClick={makeKey}>Set Key</Button>
            <Button title="QR Code" onClick={openQR}>Auth Code</Button>
            <Button title="Scan Link" onClick={openScan}>Scan Link</Button>
            <Button title="Resrvation Link" onClick={openRes}>Reservation Link</Button>
            <DropDownList
                data={[
                    {title:"Program Area Open",value: "OPEN"},
                    {title:"Temporary Hold",value: "HOLD"},
                    {title:"At Capacity",value: "CAPACITY"},
                    {title:"Program Area Closed",value: "CLOSED"},
                    {title:"Program Area Hidden",value: "HIDDEN"}
                ]}
                defaultItem={{title:"Change Area Status", value:""}}
                textField='title' 
                dataItemKey='value'
                onChange={changeStatus}
                value={{title:"Change Status", value:""}}
                fillMode='outline'
                style={{width:"150px"}}
            />
        </Toolbar>
        <Grid
            data={listData}
            dataItemKey={"AreaID"}
            selectable={{enabled:true,mode:"single"}}
            onSelectionChange={onSelectionChange}
            style={{height:"600px"}}
        >
            <GridColumn
                field="AreaID"
                title="Area ID"
                width={"150px"}
            />
            <GridColumn
                field="AreaName"
                title="Area Name"
            />
            <GridColumn
                field="ContactName"
                title="Contact"
            />
            <GridColumn
                field="ContactPhone"
                title="Phone"
            />
            <GridColumn
                field="Status"
                title="Status"
                cells={{data:IconCell}}
                width={"100px"}
            />
            <GridColumn
                field="hasKey"
                title="Active"
                cells={{data:BoolCell}}
                width={"100px"}
            />
        </Grid>
        </>
    )
}